import React from 'react';

const FormGroupTextarea = ({labelText, className = '', ...props}) => {
    return (
        <div className={'form__group form__group--textarea'}>
            <label className={'form__group-label'} dangerouslySetInnerHTML={{__html: labelText}}></label>
            <textarea
                {...props}
                className={`form__group-control ` + className}
                cols="30"
                rows="10"
            />
        </div>
    );
};

export default FormGroupTextarea;
